import { render, staticRenderFns } from "./BreakdownTotal.vue?vue&type=template&id=4e75d82b&"
import script from "./BreakdownTotal.vue?vue&type=script&lang=ts&"
export * from "./BreakdownTotal.vue?vue&type=script&lang=ts&"
import style0 from "./BreakdownTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports